const options = {
  5: "bg-orange-700/5",
  10: "bg-orange-700/10",
  25: "bg-orange-700/25",
  50: "bg-orange-700/50",
  75: "bg-orange-700/75",
  90: "bg-orange-700/90",
  100: "bg-orange-700",
};

const from = {
  5: "from-orange-700/5",
  10: "from-orange-700/10",
  25: "from-orange-700/25",
  50: "from-orange-700/50",
  75: "from-orange-700/75",
  90: "from-orange-700/90",
  100: "from-orange-700",
};

export default function getBackgroundOrange700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
